import { Injectable, OnDestroy } from '@angular/core';
import { deepCopy } from '@common/helpers';
import {
  INITIAL_PASSENGER_INFO_INPUT_MODAL_STATE,
  PassengerInformationInputModalEditArea,
} from '@common/helpers/constants/my-booking/passenger-information-input-modal.constant';
import { PassengerInformationInputModal } from '@common/interfaces';
import {
  resetPassengerInformationInputModal,
  selectPassengerInformationInputModalState,
  updatePassengerInformationInputModal,
} from '@common/store/my-booking/passenger-information-input-modal';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { GetBasicReservationInformationResponseData } from 'src/sdk-amcmember';
import { GetOrderResponseData } from 'src/sdk-servicing';

@Injectable()
export class PassengerInformationInputModalStoreService implements OnDestroy {
  private storeCurrentValueSubscription!: Subscription;
  private storeCurrentValue = INITIAL_PASSENGER_INFO_INPUT_MODAL_STATE;

  constructor(private readonly _store: Store) {
    this.storeCurrentValueSubscription = this._store
      .select(selectPassengerInformationInputModalState)
      .subscribe((val) => {
        this.storeCurrentValue = val?.model ?? INITIAL_PASSENGER_INFO_INPUT_MODAL_STATE;
      });
  }

  ngOnDestroy(): void {
    this.storeCurrentValueSubscription.unsubscribe();
  }

  setModalPayloadParts(isEditing: boolean, editArea: PassengerInformationInputModalEditArea, travelerId: string = '') {
    this.updateEditingFlag(isEditing);
    this.updateEditArea(editArea);
    this.updateTravelerId(travelerId);
  }

  updateEditingFlag(isEditing: boolean) {
    this._store.dispatch(
      updatePassengerInformationInputModal({ model: { ...deepCopy(this.storeCurrentValue), isEditing } })
    );
  }

  updateEditArea(editArea: PassengerInformationInputModalEditArea) {
    this._store.dispatch(
      updatePassengerInformationInputModal({ model: { ...deepCopy(this.storeCurrentValue), editArea } })
    );
  }

  updateTravelerId(travelerId: string) {
    this._store.dispatch(
      updatePassengerInformationInputModal({ model: { ...deepCopy(this.storeCurrentValue), travelerId } })
    );
  }

  updateOrderData(pnr?: GetOrderResponseData) {
    this._store.dispatch(updatePassengerInformationInputModal({ model: { ...deepCopy(this.storeCurrentValue), pnr } }));
  }

  updateBasicReservation(basicReservation?: GetBasicReservationInformationResponseData) {
    this._store.dispatch(
      updatePassengerInformationInputModal({ model: { ...deepCopy(this.storeCurrentValue), basicReservation } })
    );
  }

  updatePassengerInformationInputModal(value: PassengerInformationInputModal) {
    this._store.dispatch(
      updatePassengerInformationInputModal({ model: { ...deepCopy(this.storeCurrentValue), ...value } })
    );
  }

  resetPassengerInformationInputModal() {
    this._store.dispatch(resetPassengerInformationInputModal());
  }

  get editingFlag() {
    return this.storeCurrentValue.isEditing;
  }

  get editArea() {
    return this.storeCurrentValue.editArea;
  }

  get travelerId() {
    return this.storeCurrentValue.travelerId;
  }

  pnr() {
    return this.storeCurrentValue.pnr;
  }

  basicReservation() {
    return this.storeCurrentValue.basicReservation;
  }
}
